document.addEventListener('DOMContentLoaded', function() {
  
    
     // Get all top-level menu list items
      document.querySelectorAll('.list-menu--inline li').forEach(li => {
        li.addEventListener('mouseenter', () => {
          const details = li.querySelector('.mega-menu');
          if (details) {
            details.setAttribute('open', '');
          }
        });
    
        li.addEventListener('mouseleave', () => {
          const details = li.querySelector('.mega-menu');
          if (details) {
            details.removeAttribute('open');
          }
        });
      });

      

     const menuIcon = document.querySelector('.menu-icon');
      const catgoryMenu = document.querySelector('.header-search-category');
      const menuSection = document.querySelector('.seven-menu-section');
      const openCategorySection = document.querySelector('.open-category');
    
      if (menuIcon && menuSection) {
        // Show menu on icon hover
        menuIcon.addEventListener('mouseenter', function() {
          menuSection.classList.add('activated');
        });

        if (openCategorySection ) {
          openCategorySection.addEventListener('mouseenter', function() {
            menuSection.classList.add('activated');
          });
        }
    
        // Hide menu when mouse leaves menu section
        menuSection.addEventListener('mouseleave', function() {
          menuSection.classList.remove('activated');
        });
    
        // Also show on icon click (optional)
        menuIcon.addEventListener('click', function(e) {
          e.stopPropagation();
          menuSection.classList.add('activated');
        });

        catgoryMenu.addEventListener('click', function(e) {
          e.stopPropagation();
          menuSection.classList.add('activated');
        });

        
    
        // Optional: close if user clicks outside the menu or icon
        document.addEventListener('click', function(e) {
          if (!menuSection.contains(e.target) && !menuIcon.contains(e.target)) {
            menuSection.classList.remove('activated');
          }
        });
      }

    document.querySelector('.search__button-mobile').addEventListener('click', function() {
      const searchList = document.querySelector('body');
      const details = document.querySelector('details');
    
      searchList.classList.toggle('search__activated');
    
      // Open the details if not already open
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });


    document.querySelector('.modal__close-button.link').addEventListener('click', function() {
      const searchListClose = document.querySelector('body');
      const details = document.querySelector('details');
    
      // Remove class
      searchListClose.classList.remove('search__activated');
    
      // ✅ Properly close the <details>
      details.removeAttribute('open');
    });
   
    new Swiper('.top-product-swiper', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Navigation arrows
      navigation: {
        nextEl: '.top-nav-group .swiper-button-next',
        prevEl: '.top-nav-group .swiper-button-prev',
      },
      
    });

     new Swiper('.top-product-thumbnail', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Navigation arrows
      navigation: {
        nextEl: '.top-nav-group .swiper-button-next',
        prevEl: '.top-nav-group .swiper-button-prev',
      },
      
    });

    

    new Swiper('.product-media-swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true
    });

    
    new Swiper('.product-swiper', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      // Pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });

    
    new Swiper('#best-selling-products', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      autoplay: {
        delay: 39999000, // Delay between slides in ms
        disableOnInteraction: false // Keeps autoplay running after interaction
      },
      
      // Pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });

    new Swiper('.canadian-product-swiper', {
      // Optional parameters
      loop: true,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 0,
      
      // Responsive breakpoints
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
      
      // Navigation arrows
      navigation: {
        nextEl: '.canadian-proudcts .swiper-button-next',
        prevEl: '.canadian-proudcts .swiper-button-prev',
      },
      
    });


     const productSlider = document.querySelector(".product-sliders");

if (productSlider) {
  var swiper = new Swiper(".product-sliders", {
    cssMode: true,
    loop: true,
    navigation: {
      nextEl: ".product-sliders .swiper-button-next",
      prevEl: ".product-sliders .swiper-button-prev",
    },
    pagination: {
      el: ".product-sliders .swiper-pagination",
      clickable: true,
    },
  });
}

    const isDesktop = () => window.innerWidth > 1;

	let gap = 15;

	if (isDesktop()) gap = 0.0285 * window.innerWidth;

	const sliders = [];

	["#horizontal-ticker-rtl", "#horizontal-ticker-ltr"].forEach(
		(query, index) => {
			sliders.push(
				new Swiper(query, {
					loop: true,
					slidesPerView: "auto",
					spaceBetween: gap,
					speed: 15000,
					allowTouchMove: false,
					autoplay: {
						delay: 0,
						reverseDirection: index,
						disableOnInteraction: false
					}
				})
			);
		}
	);

	window.addEventListener("resize", () => {
		isDesktop() ? (gap = 0.0285 * window.innerWidth) : (gap = 15);

		sliders.forEach((slider) => {
			slider.params.spaceBetween = gap;
			slider.update();
		});
	});

// MOBILE: move media gallery before the variant/condition selector
if (window.innerWidth <= 749) {
  const mediaGallery = document.querySelector('media-gallery');
  // Target the variant picker (condition selector) as the anchor point
  const variantPicker = document.querySelector('.product__variant-picker, .product-form__input--pill, .product-form__input--dropdown, variant-selects, variant-radios');
  const title = document.querySelector('.product__title');

  if (mediaGallery) {
    if (variantPicker) {
      // Insert gallery just before the condition/variant selector
      variantPicker.parentNode.insertBefore(mediaGallery, variantPicker);
    } else if (title) {
      // Fallback: insert after title if no variant picker found
      title.parentNode.insertBefore(mediaGallery, title.nextSibling);
    }
  }
}

  });



// ═══════════════════════════════════════════════════════
// SMS WARRANTY PLAN — tier selection
// ═══════════════════════════════════════════════════════
(function() {
  function initWarranty() {
    const cards = document.querySelectorAll('.sms-warranty-card');
    const propInput = document.getElementById('sms-warranty-prop');
    if (!cards.length) return;

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        // Update visual selection
        cards.forEach(function(c) { c.classList.remove('sms-warranty-selected'); });
        card.classList.add('sms-warranty-selected');

        // Sync radio
        const radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        // Update hidden form property
        if (propInput) propInput.value = radio ? radio.value : card.dataset.tier;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWarranty);
  } else {
    initWarranty();
  }
})();



// ═══════════════════════════════════════════════════════
// SMS ACCESSORY & DELIVERY CARDS — direct cart toggle
// (accessories on product page + delivery card in cart)
// ═══════════════════════════════════════════════════════
(function() {
  function initAddonCards() {
    const cards = document.querySelectorAll('.sms-addon-card[data-variant-id]');
    if (!cards.length) return;

    // On load: mark any already-in-cart items as added
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
        cards.forEach(function(card) {
          if (cartVariantIds.includes(card.dataset.variantId)) {
            card.classList.add('is-added');
          }
        });
      })
      .catch(function() {});

    cards.forEach(function(card) {
      const btn = card.querySelector('.sms-addon-toggle-btn');
      if (!btn) return;

      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const variantId = card.dataset.variantId;
        if (!variantId) return;

        if (card.classList.contains('is-added')) {
          btn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          })
          .then(function(r) { return r.json(); })
          .then(function() { card.classList.remove('is-added'); })
          .catch(function() {})
          .finally(function() { btn.disabled = false; });
        } else {
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function() { card.classList.add('is-added'); })
          .catch(function() {})
          .finally(function() { btn.disabled = false; });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddonCards);
  } else {
    initAddonCards();
  }
})();


// ═══════════════════════════════════════════════════════
// SMS SERVICE SELECTION — Installation & Removal
// Select before Add to Cart; added alongside product
// ═══════════════════════════════════════════════════════
(function() {
  function initServiceSelectCards() {
    const section = document.querySelector('.sms-services-section');
    if (!section) return;

    const selectCards = section.querySelectorAll('.sms-service-select-card');
    if (!selectCards.length) return;

    const productTitle = section.dataset.productTitle || '';
    const formId       = section.dataset.productForm;
    const form         = formId ? document.getElementById(formId) : null;

    // Toggle selected state on button click
    selectCards.forEach(function(card) {
      const btn = card.querySelector('.sms-addon-toggle-btn');
      if (!btn) return;
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        card.classList.toggle('is-selected');
      });
    });

    // When Add to Cart is clicked, inject selected services into cart first
    if (form) {
      var atcBtn = form.querySelector('[name="add"]');
      if (atcBtn) {
        atcBtn.addEventListener('click', function() {
          var selected = section.querySelectorAll('.sms-service-select-card.is-selected');
          if (!selected.length) return;

          var items = [];
          selected.forEach(function(card) {
            var vid = card.dataset.serviceVariant;
            if (vid) {
              items.push({
                id: parseInt(vid),
                quantity: 1,
                properties: { 'For': productTitle }
              });
            }
          });

          if (!items.length) return;

          // Add services; fire-and-forget so it doesn't block ATC
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function() {
            // Deselect cards after successful add
            selected.forEach(function(c) { c.classList.remove('is-selected'); });
          })
          .catch(function() {});
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initServiceSelectCards);
  } else {
    initServiceSelectCards();
  }
})();

